import { type FormEvent, type ReactNode, useEffect, useRef } from 'react';
import { cx } from '../kit/cx.ts';
import t from '../kit/type.module.css';
import s from './Dialog.module.css';

/** A modal form (native <dialog>): Esc and the backdrop close it. */
export function Dialog({
  title,
  onClose,
  children,
  onSubmit,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  onSubmit: (e: FormEvent) => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    ref.current?.showModal();
  }, []);
  return (
    <dialog ref={ref} className={s.dialog} onClose={onClose} aria-label={title}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(e);
        }}
      >
        <h2 className={cx(t.displayS, s.dialogTitle)}>{title}</h2>
        {children}
      </form>
    </dialog>
  );
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: the control is the child
    <label className={s.field}>
      <span className={cx(t.label, s.muted)}>{label}</span>
      {children}
    </label>
  );
}
